"use client";

/**
 * PostDetailAppCta 컴포넌트
 * @description 글 끝의 "앱에서 이어서" — 댓글·좋아요·글쓴이의 다른 글은 앱에 있다.
 *
 *   글 하나로 바로 넘기지 않고 앱을 여는 데서 그친다. 블로그 응답에는 글 번호가 없고, 운영자가
 *   쓴 아티클은 애초에 앱에 없는 글이라 넘길 자리도 없다.
 */
import { Button, Card } from "@fanwork-web/design-system";
import { memo, useCallback } from "react";

import { postDetailStyles } from "./PostDetail.styles";
import type { PostDetailAppCtaProps } from "./PostDetail.types";

import { trackBlogAppOpened } from "../../analytics";
import { blogCopyOf } from "../../constants/blogCopy";
import { routes } from "@/shared/config/routes";
import { openInApp } from "@/shared/lib/deepLink";

const PostDetailAppCta = memo<PostDetailAppCtaProps>(({ post }) => {
  const copy = blogCopyOf(post).appCta;
  const open = useCallback(() => {
    trackBlogAppOpened(post);
    openInApp(routes.home);
  }, [post]);

  return (
    <Card
      slot={
        <div className={postDetailStyles.cta.root}>
          <div className={postDetailStyles.cta.texts}>
            <p className={postDetailStyles.cta.title}>{copy.title}</p>
            <p className={postDetailStyles.cta.description}>
              {copy.description}
            </p>
          </div>
          <Button
            text={copy.action}
            tone="brand"
            radius="circle"
            onClick={open}
          />
        </div>
      }
    />
  );
});

PostDetailAppCta.displayName = "PostDetailAppCta";

export default PostDetailAppCta;
